import React from 'react';
import {
    Controller,
    FieldValues,
    UseFormRegister,
    RegisterOptions,
    Control,
} from 'react-hook-form';
import { useAppSelector } from '../../../../store/hooks/StoreHooks';

export interface DynamicCheckboxProps {
    name: string;
    label?: string;
    className?: string;
    register?: UseFormRegister<FieldValues>;
    rules?: RegisterOptions;
    control?: Control<FieldValues>;
    error?: string;
    render?: (field: any) => React.ReactNode;
    [key: string]: any;
}

const Checkbox: React.FC<DynamicCheckboxProps> = ({
    name,
    label,
    className,
    register,
    rules,
    control,
    error,
    render,
    onChange,
    value,
    ...rest
}) => {
    const { customerEnabled, customerCreated } = useAppSelector((state) => state.auth);
    const { projectReadOnly } = useAppSelector((state) => state.projectHeader);
    const isDisabled = (customerEnabled && !customerCreated) || projectReadOnly;
    
    return (
        <div className={`flex items-center gap-2 ${className}`}>
            {control ? (
                <Controller
                    name={name}
                    control={control}
                    rules={rules}
                    render={({ field }) => (
                        <input
                            id={name}
                            type="checkbox"
                            checked={value || false}
                            onChange={(e) => {
                                onChange(e.target.checked);
                            }}
                            disabled={isDisabled}
                            aria-invalid={!!error}
                            className={`form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                        />
                    )
                    }
                />
            ) : register ? (
                <input
                    id={name}
                    type="checkbox"
                    {...register(name, rules)}
                    disabled={isDisabled}
                    aria-invalid={!!error}
                    className={`form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                    {...rest}
                />
            ) : (
                <input
                    id={name}
                    type="checkbox"
                    disabled={isDisabled}
                    aria-invalid={!!error}
                    className={`form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                    {...rest}
                />
            )}
            {label && <label htmlFor={name} className={`ml-[8px] text-[14px] font-semibold ${isDisabled ? 'text-neutral-200' : 'text-neutral-25'}`}>{label}</label>}
            {error && <span style={{ color: 'red' }}>{error}</span>}
        </div>
    );
};

export default Checkbox;
